import { render, staticRenderFns } from "./SeparationAnxietyForm.vue?vue&type=template&id=bbacbf94&"
import script from "./SeparationAnxietyForm.vue?vue&type=script&lang=js&"
export * from "./SeparationAnxietyForm.vue?vue&type=script&lang=js&"
import style0 from "./SeparationAnxietyForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports